"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _validationsEnum = _interopRequireDefault(require("../constants/validationsEnum"));

var _CurrencyInput = require("../fields/CurrencyInput.config");

var _PhoneInput = require("../fields/PhoneInput.config");

var _formValidations = require("./formValidations");

var _lodash = require("lodash");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var validateInput = function validateInput(_ref) {
  var validations = _ref.validations,
      validationDependency = _ref.validationDependency,
      value = _ref.value,
      errorHandler = _ref.errorHandler,
      id = _ref.id,
      opts = _ref.opts,
      customValidations = _ref.customValidations,
      dependencies = _ref.dependencies,
      min = _ref.min,
      max = _ref.max,
      minLength = _ref.minLength,
      maxLength = _ref.maxLength,
      regex = _ref.regex,
      regexError = _ref.regexError,
      requiredSelection = _ref.requiredSelection,
      requiredSelectionErrorMessage = _ref.requiredSelectionErrorMessage;

  var errors = _defineProperty({}, id, []);

  var validationDepKey;
  var validationDepValue;

  if (validationDependency) {
    var _Object$values$;

    validationDepKey = Object.keys(validationDependency)[0];
    validationDepValue = typeof validationDependency === 'string' ? validationDependency : validationDependency ? (_Object$values$ = Object.values(validationDependency)[0]) === null || _Object$values$ === void 0 ? void 0 : _Object$values$.toString() : undefined;
  }

  if (validations || customValidations && Object.keys(customValidations).length > 0) {
    if (!(0, _formValidations.fieldIsEmpty)(value)) {
      var validationsPromises = _toConsumableArray(new Set(validations)).map( /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(validation) {
          var _parseCurrencyValue, currency, amount, _parsePhoneNumber, prefix, number;

          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.t0 = validation;
                  _context.next = _context.t0 === _validationsEnum.default.REQUIRED ? 3 : _context.t0 === _validationsEnum.default.REQUIRED_CURRENCY ? 4 : _context.t0 === _validationsEnum.default.ALPHABETIC ? 10 : _context.t0 === _validationsEnum.default.EMAIL ? 11 : _context.t0 === _validationsEnum.default.CONFIRM_EMAIL ? 12 : _context.t0 === _validationsEnum.default.PHONE ? 13 : _context.t0 === _validationsEnum.default.LIST_OPTIONS ? 15 : _context.t0 === _validationsEnum.default.DATE_IS_VALID ? 16 : _context.t0 === _validationsEnum.default.MONTH_IS_VALID ? 17 : _context.t0 === _validationsEnum.default.YEAR_IS_VALID ? 18 : _context.t0 === _validationsEnum.default.DATE_IS_NOT_IN_THE_FUTURE ? 19 : _context.t0 === _validationsEnum.default.DATE_IS_NOT_IN_THE_PAST ? 20 : _context.t0 === _validationsEnum.default.DATE_IS_BETWEEN_DATES ? 21 : _context.t0 === _validationsEnum.default.CREDIT_CARD_IS_VALID ? 22 : _context.t0 === _validationsEnum.default.IBAN_IS_VALID ? 23 : _context.t0 === _validationsEnum.default.BIC_IS_VALID ? 24 : _context.t0 === _validationsEnum.default.SORT_CODE_IS_VALID ? 25 : _context.t0 === _validationsEnum.default.URL ? 26 : _context.t0 === _validationsEnum.default.MIN_LENGTH ? 27 : _context.t0 === _validationsEnum.default.MAX_LENGTH ? 28 : _context.t0 === _validationsEnum.default.REGEX_CHECK ? 29 : _context.t0 === _validationsEnum.default.REQUIRED_SELECTION ? 30 : 31;
                  break;

                case 3:
                  return _context.abrupt("return", ((0, _formValidations.fieldIsEmpty)(value) || value === 0) && {
                    key: id,
                    value: 'errors.required'
                  });

                case 4:
                  _parseCurrencyValue = (0, _CurrencyInput.parseCurrencyValue)(value), currency = _parseCurrencyValue.currency, amount = _parseCurrencyValue.amount;

                  if (!(!!amount && !currency)) {
                    _context.next = 7;
                    break;
                  }

                  return _context.abrupt("return", {
                    key: id,
                    value: 'errors.currencyTypeRequired'
                  });

                case 7:
                  if (!(!!currency && !amount)) {
                    _context.next = 9;
                    break;
                  }

                  return _context.abrupt("return", {
                    key: id,
                    value: 'errors.currencyAmountRequired'
                  });

                case 9:
                  return _context.abrupt("return", false);

                case 10:
                  return _context.abrupt("return", (0, _formValidations.textIsNotAlphabetic)(value) && {
                    key: id,
                    value: 'errors.notAlphabetic'
                  });

                case 11:
                  return _context.abrupt("return", (0, _formValidations.emailIsNotValid)(value) && {
                    key: id,
                    value: 'errors.emailValid'
                  });

                case 12:
                  return _context.abrupt("return", (0, _formValidations.emailIsNotEqual)(value, validationDependency) && {
                    key: id,
                    value: 'errors.confirmEmailError'
                  });

                case 13:
                  _parsePhoneNumber = (0, _PhoneInput.parsePhoneNumber)(value), prefix = _parsePhoneNumber.prefix, number = _parsePhoneNumber.number;
                  return _context.abrupt("return", !prefix && number ? {
                    key: id,
                    value: 'errors.phonePrefixRequired'
                  } : (0, _formValidations.phoneIsNotValid)(value) && {
                    key: id,
                    value: 'errors.phoneNotValid'
                  });

                case 15:
                  return _context.abrupt("return", (0, _formValidations.listOptionsAreValid)(value, validationDependency) && {
                    key: id,
                    value: 'errors.listOptions'
                  });

                case 16:
                  return _context.abrupt("return", (0, _formValidations.dateIsNotValid)({
                    value: value,
                    type: 'DATE'
                  }) && {
                    key: id,
                    value: 'errors.dateIsNotValid'
                  });

                case 17:
                  return _context.abrupt("return", (0, _formValidations.dateIsNotValid)({
                    value: value,
                    type: 'MONTH'
                  }) && {
                    key: id,
                    value: 'errors.monthIsNotValid'
                  });

                case 18:
                  return _context.abrupt("return", (0, _formValidations.dateIsNotValid)({
                    value: value,
                    type: 'YEAR'
                  }) && {
                    key: id,
                    value: 'errors.yearIsNotValid'
                  });

                case 19:
                  return _context.abrupt("return", (0, _formValidations.dateIsNotInTheFuture)({
                    value: value,
                    id: id
                  }));

                case 20:
                  return _context.abrupt("return", (0, _formValidations.dateIsInNotInThePast)({
                    value: value,
                    id: id
                  }));

                case 21:
                  return _context.abrupt("return", (0, _formValidations.dateIsInBetweenDates)({
                    value: value,
                    id: id,
                    min: min,
                    max: max
                  }));

                case 22:
                  return _context.abrupt("return", !(0, _formValidations.creditCardIsValid)(value) && {
                    key: id,
                    value: 'errors.creditCardIsNotValid'
                  });

                case 23:
                  return _context.abrupt("return", !(0, _formValidations.ibanIsValid)(value) && {
                    key: id,
                    value: 'errors.ibanIsNotValid'
                  });

                case 24:
                  return _context.abrupt("return", !(0, _formValidations.bicIsValid)(value) && {
                    key: id,
                    value: 'errors.bicIsNotValid'
                  });

                case 25:
                  return _context.abrupt("return", !(0, _formValidations.sortCodeIsValid)(value) && {
                    key: id,
                    value: 'errors.sortCodeIsNotValid'
                  });

                case 26:
                  return _context.abrupt("return", (0, _formValidations.urlIsNotValid)(value) && {
                    key: id,
                    value: 'errors.urlNotValid'
                  });

                case 27:
                  return _context.abrupt("return", (0, _formValidations.minLengthNotReached)(value, minLength) && {
                    key: id,
                    id: 'errors.minLength',
                    data: {
                      data: minLength
                    }
                  });

                case 28:
                  return _context.abrupt("return", (0, _formValidations.maxLengthSurpassed)(value, maxLength) && {
                    key: id,
                    id: 'errors.maxLength',
                    data: {
                      data: maxLength
                    }
                  });

                case 29:
                  return _context.abrupt("return", !(0, _formValidations.matchesRegex)(value, regex) && {
                    key: id,
                    value: regexError
                  });

                case 30:
                  return _context.abrupt("return", value !== requiredSelection && {
                    key: id,
                    value: requiredSelectionErrorMessage
                  });

                case 31:
                  if (!(!(0, _lodash.isEmpty)(customValidations) && customValidations.hasOwnProperty(validation))) {
                    _context.next = 35;
                    break;
                  }

                  return _context.abrupt("return", customValidations[validation]({
                    validationDependency: validationDependency,
                    validationDepValue: validationDepValue,
                    value: value,
                    errorHandler: errorHandler,
                    id: id,
                    opts: opts
                  }));

                case 35:
                  return _context.abrupt("return", false);

                case 36:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function (_x) {
          return _ref2.apply(this, arguments);
        };
      }());

      Promise.all(validationsPromises).then(function (res) {
        res.forEach(function (error) {
          return error && errors[id].push(error.data ? error : error.value);
        });
        errorHandler(errors);
      });
    } else {
      var _dependencies$validat;

      var validationsArray = dependencies !== null && dependencies !== void 0 && (_dependencies$validat = dependencies[validationDepKey]) !== null && _dependencies$validat !== void 0 && _dependencies$validat[validationDepValue] ? !value ? [].concat(_toConsumableArray(dependencies[validationDepKey][validationDepValue]), _toConsumableArray(validations || [])) : validations : validations;

      if (validationsArray && validationsArray.includes('REQUIRED')) {
        errors[id].push('errors.required');
        errorHandler(errors);
      } else if (validationsArray.includes(_validationsEnum.default.REQUIRED_SELECTION)) {
        if (value !== requiredSelection) {
          errors[id].push(requiredSelectionErrorMessage);
        }

        errorHandler(errors);
      } else {
        var errorsUpdate = _objectSpread({}, errors);

        errorsUpdate[id] = false;
        errorHandler(errorsUpdate);
      }
    }
  }
};

var _default = validateInput;
exports.default = _default;